import bulkServiceervice from "../../services/bulkPriceTransactionService";
import {
    BULK_ADD_REQUEST,
    BULK_ADD_FAILURE,
    BULK_ADD_SUCCESS,
    BULK_GET_FAILURE,
    BULK_GET_REQUEST,
    BULK_GET_SUCCESS,
     } from "./actionTypes";



export const fetchBulk = (authUserId,token,page,pageSize) => {
   
    return async (dispatch) => {
      dispatch({ type: BULK_GET_FAILURE });
      try {
        const response = await bulkServiceervice.fetchBulkPrice(authUserId,token,page,pageSize);
        const { data } = response;
        dispatch({ type: BULK_GET_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: BULK_GET_REQUEST, error: error.message });
        return Promise.reject(error); 
      }
    };
  };

  export const addBulk = (bulkdata,token) => {
    return async (dispatch) => {
      dispatch({ type: BULK_ADD_REQUEST });
      try {
        const response = await bulkServiceervice.addBulkPrice(bulkdata,token);
        const { data } = response;
        dispatch({ type: BULK_ADD_SUCCESS, payload: data });
        return data; 
      } catch (error) {
        dispatch({ type: BULK_ADD_FAILURE, error: error.message });
        return Promise.reject(error); 
      }
    };
  };
